const replaceSpecialCharactersMixin = {
  methods: {
    replaceSpecialCharacters(replaceString) {
      if (replaceString) {
        return replaceString.replace(/\D+/g, '')
      }
      return false
    },
    removeSpecialCharaters(text) {
      return text.replace(/[^a-zA-Z0-9]/g, '')
    },
  },
}

export default replaceSpecialCharactersMixin
